import React from "react";
import SecurityPage from './securityPage/securityPage.Container';
/* Package JSON Import will be here */

/* Project Import will be here */
import Layout from '../../comman/Layout/Layout';
/* Project Import will be here */

/* Styles will be here */
// import './sales.css';
/* Styles will be here */

/* Const,Let & Var will be here */
// const Search = Input.Search;
/* Const,Let & Var will be here */

const SecurityComponent = (props) => {
    return (
        <Layout>
            {props.security.isSecurityClicked && <SecurityPage />}
        </Layout>
    );
}

export default SecurityComponent;

SecurityComponent.displayName = "SecurityComponent";